import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { SubmitPetsInfoResponse } from '../@types/SubmitPetsInfo'

type Store = {
  submitPetsInfo: SubmitPetsInfoResponse | null
  setSubmitPetsInfo: (value: SubmitPetsInfoResponse) => void
}

export const useSubmitPetsInfoStore = create<Store>()(
  devtools(
    (set) => ({
      submitPetsInfo: null,
      setSubmitPetsInfo: (submitPetsInfo) => set({ submitPetsInfo }),
    }),
    { name: 'SubmitPetsInfoStore' },
  ),
)
